import { render, staticRenderFns } from "./PsCalendar.vue?vue&type=template&id=76225bdb&scoped=true&"
import script from "./PsCalendar.vue?vue&type=script&lang=js&"
export * from "./PsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76225bdb",
  null
  
)

export default component.exports